const translations = {
    connectionError: 'Could not reach compatibility service — retry?'
};

export default translations;
